import React, { memo } from 'react';
import type { ApplicationData } from '../types';

interface ApplicantInfoSectionProps {
  application: ApplicationData;
  isEditing: boolean;
  editedData: Partial<ApplicationData>;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ApplicantInfoSectionComponent: React.FC<ApplicantInfoSectionProps> = ({
  application,
  isEditing,
  editedData,
  onInputChange
}) => {
  return (
    <div className="p-4 md:p-8">
      <h2 className="text-[#1e2c49] text-lg md:text-xl font-bold font-['Pretendard'] leading-9 mb-3 md:mb-4">
        신청자 정보
      </h2>
      <div className="w-full md:w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6 md:mb-8"></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        <div>
          <p className="text-[#6b7684] text-sm md:text-lg font-medium mb-2">이름</p>
          {isEditing ? (
            <input
              type="text"
              name="name"
              value={editedData.name || ''}
              onChange={onInputChange}
              className="w-full h-10 md:h-12 bg-white rounded-sm outline outline-[0.50px] outline-gray-300 px-3 md:px-4 text-[#1e2c49] text-base md:text-[19px] font-semibold"
            />
          ) : (
            <p className="text-[#1e2c49] text-base md:text-[19px] font-semibold break-all">{application.name}</p>
          )}
        </div>
        <div>
          <p className="text-[#6b7684] text-sm md:text-lg font-medium mb-2">소속</p>
          {isEditing ? (
            <input
              type="text"
              name="organization"
              value={editedData.organization || ''}
              onChange={onInputChange}
              className="w-full h-10 md:h-12 bg-white rounded-sm outline outline-[0.50px] outline-gray-300 px-3 md:px-4 text-[#1e2c49] text-base md:text-[19px] font-semibold"
            />
          ) : (
            <p className="text-[#1e2c49] text-base md:text-[19px] font-semibold break-all">{application.organization}</p>
          )}
        </div>
        <div>
          <p className="text-[#6b7684] text-sm md:text-lg font-medium mb-2">이메일</p>
          <p className="text-[#1e2c49] text-base md:text-[19px] font-semibold break-all">{application.email}</p>
        </div>
        <div>
          <p className="text-[#6b7684] text-sm md:text-lg font-medium mb-2">연락처</p>
          {isEditing ? (
            <input
              type="tel"
              name="phoneNumber"
              value={editedData.phoneNumber || ''}
              onChange={onInputChange}
              className="w-full h-10 md:h-12 bg-white rounded-sm outline outline-[0.50px] outline-gray-300 px-3 md:px-4 text-[#1e2c49] text-base md:text-[19px] font-semibold"
            />
          ) : (
            <p className="text-[#1e2c49] text-base md:text-[19px] font-semibold break-all">{application.phoneNumber}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export const ApplicantInfoSection = memo(ApplicantInfoSectionComponent);
